const MIN_HTML_LENGTH = 200;

export function isStubHtmlResponse(html: string): boolean {
  return html.length < MIN_HTML_LENGTH;
}
